import { tt } from '@agos/shared'

export { weekRows } from '@agos/customer-core'

/**
 * The day names the footer prints.
 *
 * Here rather than in `@agos/customer-core` because they are words on a screen and that package holds no
 * copy — `weekRows` returns day *keys* precisely so the grouping can be tested without a translator.
 */
export const DAY_LABELS: Record<string, string> = {
  mon: tt('Pondelok'),
  tue: tt('Utorok'),
  wed: tt('Streda'),
  thu: tt('Štvrtok'),
  fri: tt('Piatok'),
  sat: tt('Sobota'),
  sun: tt('Nedeľa'),
}
